export const GET_MESSAGES = 'GET_MESSAGES' as const;
export const getMessages = () => ({
  type: GET_MESSAGES,

});
export type GetMessages = ReturnType<typeof getMessages>;

export const SELECT_ALL_MESSAGES = 'SELECT_ALL_MESSAGES' as const;
export const selectAllMessages = (isChecked: boolean) => ({
  type: SELECT_ALL_MESSAGES,
  isChecked,
});
export type SelectAllMessages = ReturnType<typeof selectAllMessages>;

export const SELECT_ONE_MESSAGE = 'SELECT_ONE_MESSAGE' as const;
export const selectOneMessage = (messageId: number) => ({
  type: SELECT_ONE_MESSAGE,
  messageId,
});
export type SelectOneMessage = ReturnType<typeof selectOneMessage>;

export const READ_MESSAGE = 'READ_MESSAGE' as const;
export const setMessageRead = (messageId: number) => ({
  type: READ_MESSAGE,
  messageId,
});
export type SetMessageRead = ReturnType<typeof setMessageRead>;

export type SecuredMessagingPageActions = GetMessages | SelectAllMessages | SelectOneMessage | SetMessageRead;
